module.exports = __webpack_public_path__ + "static/ralph-weber.1eea0381.webp";